module.exports = "https://tutorchat.chegg.com/static/media/ic-math.e70a0d28.svg";